
import { Component, Vue } from 'vue-property-decorator'
import ContentList from '@/components/listView/ContentList.vue'
import whitelabelModule from '@/store/whitelabel'
import beaconModule from '@/store/beacon'
import dealModule from '@/store/deal'
import venueModule from '@/store/venue'
import { Beacon } from '@/types/Beacon'
import { Deal } from '@/types/Deal'

@Component({
  name: 'BeaconDealEditor',
  components: {
    ContentList
  }
})
class BeaconDealEditor extends Vue {
  private dialog = true
  private form = {
    beacon: '',
    deal: ''
  }

  private get storeModule() {
    return beaconModule
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get venue() {
    return venueModule.venue
  }

  private get beacons() {
    return beaconModule.beacons
  }

  private get deals() {
    return dealModule.deals
  }

  private get beaconDeals() {
    return beaconModule.beaconDeals
  }

  private get freeBeacons() {
    return beaconModule.beacons.filter(beacon => {
      for (const deal of this.beaconDeals) {
        if ((deal.beacon as Partial<Beacon>)._id === beacon._id) {
          return false
        }
      }
      return true
    })
  }

  private get headers() {
    return [
      { text: 'Beacon', value: 'uuid' },
      { text: 'Deal', value: 'name' }
    ]
  }

  private get items() {
    return this.beaconDeals.map(el => {
      return { uuid: (el.beacon as Beacon).uuid, name: (el.deal as Deal).name }
    })
  }

  private async created() {
    await dealModule.fetchByVenue({ limit: 0, venueId: this.venue!._id })
    await beaconModule.fetchAllDeals({ limit: 0, venueId: this.venue!._id })
  }

  private saveBeaconDeal() {
    beaconModule.createDeal({
      whitelabel: this.whitelabel._id,
      beaconDeal: {
        venue: this.venue!._id,
        beacon: this.form.beacon,
        deal: this.form.deal
      }
    })
    this.dialog = false
  }
}

export default BeaconDealEditor
